import Dropdown from "react-bootstrap/Dropdown";
import EmptyTableRow from "../../../common/EmptyTableRow";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {useReadFormula} from "./hooks/useReadFormula";
import {AnalyzeFormulaElementType} from "./interface";
import {useUpdateFormula} from "./hooks/useUpdateFormula";


export default function AnalyzeFormula() {
    const {goToNavigation} = useGoToNavigation();

    const {data: formulaList} = useReadFormula()
    const {mutate: mutateUpdateFormula} = useUpdateFormula()

    const btnGoToList = () => {
        goToNavigation("inventory/analyze/list", {}, false)
    }

    const btnHide = (el: AnalyzeFormulaElementType) => {
        const flag = el.isHidden === "Y" ? "N" : "Y"

        mutateUpdateFormula([{formulaInfoId: el.formulaInfoId, isHidden: flag}])
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">수식 설정</h3>
            <div className="filter_toolbar">
                <button className="btn btn-outline-primary w-100px h-38px" onClick={btnGoToList}><img
                    src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록
                </button>
                {/* NOTE: 수정 버튼은 숨기기를 위한 버튼이고, 드롭다운 메뉴에서 숨길 수 있으므로 제거 */}
                {/*<button className="btn btn-secondary w-100px h-38px">수정</button>*/}
            </div>
        </div>
        <div className="table_top">
            <h6 className="table_stats">수식 설정 목록(<span>{formulaList?.FormulaList?.length}</span>건)</h6>
        </div>
        <table className="table table-bordered my_table">
            <thead>
            <tr>
                <th style={{width: "25%"}}>이름</th>
                <th style={{width: "40%"}}>수식</th>
                <th style={{width: "15%"}}>표시형식</th>
                <th style={{width: "15%"}}>집계 방식</th>
                <th style={{width: "5%"}}></th>
            </tr>
            </thead>
            <tbody>
            {formulaList?.FormulaList?.length !== 0 ?
                formulaList?.FormulaList?.map((el: AnalyzeFormulaElementType) => (<tr>
                    <td>{el.formulaName}</td>
                    <td>{el.formulaData}</td>
                    <td className="text-center">{el.formatType}</td>
                    <td className="text-center">{el.calculationType}</td>
                    <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            {el.isHidden === "Y" &&
                                <button className="btn btn-default btn_td">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon-hide-eye.png"} alt=""/>
                                </button>
                            }
                            <Dropdown>
                                <Dropdown.Toggle className="dots_dropdown" variant="link">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon-dots.png"} alt=""/>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        onClick={() => btnHide(el)}>
                                        수식 {el.isHidden === "N" ? "숨기기" : "표시하기"}
                                    </Dropdown.Item>
                                    {/* NOTE: 삭제 없음 */}
                                    {/*<Dropdown.Item href="#/action-2">삭제하기</Dropdown.Item>*/}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </td>
                </tr>))
                : <EmptyTableRow colSpan={6}/>
            }
            </tbody>
        </table>
    </div>
    
}